module.exports = __webpack_public_path__ + "static/media/cup.8a049af6.svg";